import { render, staticRenderFns } from "./DetectionSets.vue?vue&type=template&id=21f31282&scoped=true&"
import script from "./DetectionSets.vue?vue&type=script&lang=js&"
export * from "./DetectionSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f31282",
  null
  
)

export default component.exports